module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/guest_list-85f3f243a2259bf1ef7ff0c3a16d3ae6.jpg";